// extracted by mini-css-extract-plugin
export default {"page":"ObjectInfo_page__xdtv3","image":"ObjectInfo_image__vJDfP","info":"ObjectInfo_info__IdGF6","toolbar":"ObjectInfo_toolbar__hipCd","describe":"ObjectInfo_describe__-3-Fq"};